module.exports = __webpack_public_path__ + "media/images/company/company_02-bb8f2d4f4b9aa5238c4e37a65e329e1a.jpg";